import { render, staticRenderFns } from "./initiator.vue?vue&type=template&id=11c00975&scoped=true"
import script from "./initiator.vue?vue&type=script&lang=js"
export * from "./initiator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c00975",
  null
  
)

export default component.exports